<template>
  <div class="b-bar-chart">
    <div class="b-bar__chart">
      <barChart
        :labels="chartData.labels"
        :datasets="chartData.datasets"></barChart>
    </div>
    <div  v-if="chartData.legend" class="b-chart-legend">
      <ul>
        <li v-for="(legend, index) in chartData.legend" :key="index">
     
          <div class="b-chart-legend__color"  
          
          :style="{
              'background-color': chartData.datasets[index].backgroundColor,
            }"></div>         
          <div class="b-chart-legend__name">{{legend}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import barChart from './bar-chart.vue'

export default {
  components: {
    barChart,
  },
  props: {
    chartData: {
      required: true,
      type: Object,
    },
  },
  computed: {},
}
</script>
